export default "/_next/static/images/img3-39fa7656aa08a96bc1b8c9a0236cf0be.png";